import React from 'react';

import { Box, Tab, Tabs } from 'components';

import { ApiClientTokensList } from './ApiClientTokensList';

import { useTranslation } from 'third-party';

import { apiSpecEndpoint } from 'constants/endpoints';

type TabPanelProps = {
  children?: React.ReactNode;
  index: number;
  value: number;
};

const CustomTabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
  ...other
}) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`api-tabpanel-${index}`}
    aria-labelledby={`api-tab-${index}`}
    style={{ height: value === index ? '100%' : undefined }}
    {...other}
  >
    {value === index && children}
  </div>
);

const a11yProps = (index: number) => ({
  id: `api-tab-${index}`,
  'aria-controls': `api-tabpanel-${index}`,
});

export const ApiDocs = () => {
  const { t } = useTranslation();
  const [value, setValue] = React.useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="api tabs">
          <Tab label={t('apiDocs.tab.documentation')} {...a11yProps(0)} />
          <Tab label={t('apiDocs.tab.tokens')} {...a11yProps(1)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <iframe
          src={apiSpecEndpoint()}
          frameBorder="0"
          height="100%"
          width="100%"
          style={{ display: 'block', minHeight: '80vh' }}
        />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <ApiClientTokensList />
      </CustomTabPanel>
    </Box>
  );
};
